<script setup lang="ts">
import BoNoticeDocVarField from './BoNoticeDocVarField.vue';
import BoLetterHead from './parts/BoLetterHead.vue';
import BoLetterClose from './parts/BoLetterClose.vue';
</script>

<template>
  <div class="bo-doc">
    <BoLetterHead :paren-reg="false" recipient-mode="individual_member" />
    <p class="doc-p">
      <BoNoticeDocVarField field-key="company_name" />
      [Company Registration No. <BoNoticeDocVarField field-key="company_registration_no" />]
    </p>
    <p class="doc-p">
      Pursuant to subsection 60C(1) of the CA 2016, as a member of the Company you are required to inform and
      confirm whether or not you are the beneficial owner of the Company within 30 days from the date of this notice.
    </p>
    <p class="doc-p">
      <b>2</b><br />
      If your answer in paragraph 1 above is YES, please proceed to Appendix A for your reply.
    </p>
    <p class="doc-p">
      <b>3</b><br />
      If your answer in paragraph 1 above is NO, please proceed to Appendix B for your reply. You are required to
      indicate the persons by name and particulars sufficient to enable those persons to be identified as beneficial
      owner(s) of the Company.
    </p>
    <p class="doc-p"><b>4</b><br />Please include the following declaration as part of your reply:</p>
    <p class="doc-p" style="padding-left:16px; font-style:italic">
      “I hereby confirmed that the facts and information stated in this letter are true and to the best of my knowledge and belief.”
    </p>
    <p class="doc-p">
      <b>5</b><br />
      Please be informed that any person who fails to comply with this notice commits an offence under subsection
      60C(7) of the CA 2016 and/or provides false or misleading information commits an offence under section 593 of
      the CA 2016.
    </p>
    <BoLetterClose var-key="BO02" designation-key="signer_designation_BO02" />
    <p class="doc-attn">
      <b>[Note to the Company:</b> If the Company has taken all reasonable steps to identify its beneficial owner and
      arrived at the conclusion that:<br /><br />
      (a) the Company has no beneficial owner;<br />
      (b) the beneficial owner of the Company cannot be identified; or<br />
      (c) the Company is still in the process of obtaining the beneficial ownership information,<br /><br />
      the Company is required to provide the information of its senior management in place of a beneficial owner.
      Please proceed to Appendix C and provide the name and particulars of the senior management of the Company.]
    </p>
  </div>
</template>

<style src="./boNoticeDoc.css"></style>
